<div class="border-bottom-grey">
  <form [formGroup]="AddReportForm" id="AddReportForm">
    <div class="position-reletivediv popup-inner-space">
      <div class="text-right flow-right d-flex justify-content-between">
        <h4
          id="heading-control"
          class="right-sidebar-heading color_black mb-0"
          id="dashboard-main"
        >
          Report Configuration
        </h4>
        <img
          src="assets/images/close_icon.svg"
          alt="..."
          class="img-fluid closeicon2 cursor-pointer"
          (click)="Close()"
        />
      </div>
    </div>
  </form>
</div>
<div class="container">
  <form [formGroup]="AddReportForm" id="AddReportForm">
    <div class="container-data56">
      <div class="main-errormsg-1" *ngIf="errorMsg">{{ errorMsg }}</div>
      <div
        class="sucessmsg error-fix"
        *ngIf="successMsg"
        style="margin-left: 0%; margin-top: -1%"
      >
        {{ successMsg }}
      </div>
    </div>
    <div class="row report_btn mt-3">
      <div class="col-lg-12 d-flex cursor-pointer">
        <div>
          <input
            id="Single"
            type="radio"
            value="Single"
            name="ReportType"
            formControlName="ReportType"
            (change)="radioChange('Single')"
          />
          <label for="Single" class="ml-1 add_report_pos text-dark"
            >Single Meter</label
          >
        </div>
        <!-- <div class="ml-4">
                    <input id="Multiple" type="radio" value="Multiple" name="ReportType" formControlName="ReportType"
                        (change)="radioChange('Multiple')">
                    <label for="Multiple" class="ml-1 add_report_pos text-dark">Multiple Meter</label>
                </div> -->
      </div>
    </div>
    <div class="row mt-2 p-2">
      <div
        class="col-sm-3 col-md-3 col-lg-3 mb-2 padding-left-10 padding-right-0"
        *ngIf="isDisplayCombo"
      >
        <div class="fxg-field fxg-field2">
          <mat-form-field
            style="display: block"
            id="Site-Name-control"
            title="Report Type"
          >
            <mat-select
              formControlName="MeterReportType"
              (selectionChange)="OnChangeMRT($event)"
            >
              <mat-option value="">(Select Report Type)</mat-option>
              <mat-option
                MatFormFieldControl="MeterReportType"
                *ngFor="let lstsite of ReporttypeList"
                [value]="lstsite.CodeValue"
              >
                {{ lstsite.CodeDescription }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span class="error_msg" *ngIf="displayMessage.MeterReportType">{{
            displayMessage.MeterReportType
          }}</span>
        </div>
      </div>
      <div
        class="col-sm-3 col-md-3 col-lg-3 mb-2 padding-left-10 padding-right-0"
      >
        <div class="fxg-field fxg-field2">
          <label style="display: none" class="Navuser" id="Company-Name"
            >Company Name
          </label>
          <input
            formControlName="ReportName"
            id="ReportName"
            [readonly]="IsreadOnly"
            type="text"
            (keyup)="onKeypressEvent($event)"
            class="fxg-field__input-text fxg-field__input--required sessioncamexclude"
          />
          <span
            class="fxg-field__placeholder fxg-field__floating-placeholder custom-placeholder"
            tabindex="-1"
            >Report Name</span
          >
          <div class="main-errormsg" *ngIf="displayMessage.ReportName">
            {{ displayMessage.ReportName }}
          </div>
        </div>
      </div>
      <div
        class="col-sm-2 col-md-2 col-lg-2 mb-2 pr-10 padding-left-10"
        *ngIf="isDisplayCombo"
      >
        <div class="fxg-field fxg-field2">
          <mat-form-field
            style="display: block"
            id="Site-Name-control"
            title="Site Name"
          >
            <mat-select
              formControlName="SiteId"
              (selectionChange)="OnChangeSite($event)"
            >
              <mat-option value="">(Select Site)</mat-option>
              <mat-option
                MatFormFieldControl="SiteId"
                *ngFor="let lstsite of SiteList"
                [value]="lstsite.CodeValue"
              >
                {{ lstsite.CodeDisplayText }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span class="error_msg" *ngIf="displayMessage.SiteId">{{
            displayMessage.SiteId
          }}</span>
        </div>
      </div>
      <div
        class="col-sm-2 col-md-2 col-lg-2 mb-2 pl-0 pr-10"
        *ngIf="isDisplayCombo"
      >
        <div class="fxg-field fxg-field2">
          <mat-form-field
            style="display: block"
            id="Panel-Name"
            title="Panel Name"
          >
            <mat-select
              formControlName="PanelId"
              (selectionChange)="OnChangePanel($event)"
            >
              <mat-option value="">(Select Location)</mat-option>
              <mat-option
                MatFormFieldControl="PanelId"
                *ngFor="let lstpanel of PanelList"
                [value]="lstpanel.CodeValue"
              >
                {{ lstpanel.CodeDisplayText }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span class="error_msg" *ngIf="displayMessage.PanelId">{{
            displayMessage.PanelId
          }}</span>
        </div>
      </div>
      <div
        class="col-sm-2 col-md-2 col-lg-2 padding-right-5 d-flex mb-2 pl-0"
        *ngIf="isDisplayCombo"
      >
        <div class="fxg-field fxg-field2">
          <mat-form-field
            style="display: block"
            id="Meter-Name"
            title="Meter Name"
          >
            <mat-select
              formControlName="EnergymeterId"
              (selectionChange)="OnChangeEnergymeter($event)"
            >
              <mat-option value="">(Select Meter)</mat-option>
              <mat-option
                MatFormFieldControl="EnergymeterId"
                *ngFor="let lstenergymeter of EnergymeterList"
                [value]="lstenergymeter.CodeValue"
              >
                {{ lstenergymeter.CodeDisplayText }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span class="error_msg" *ngIf="displayMessage.EnergymeterId">{{
            displayMessage.EnergymeterId
          }}</span>
        </div>
      </div>
    </div>
  </form>
  <div class="company-btn2_1">
    <button
      id="btnNewdashboardSave"
      class="btncommon btn-orange btn-border-add-company width-fix67 ml-24"
      (click)="SaveReport()"
    >
      Save
    </button>
  </div>
</div>
